<ng-container [ngTemplateOutlet]="bookingHeaderSummary" />

<ng-template #bookingHeaderSummary>
  <div
    class="flex flex--middle summary-wrapper"
    [ngClass]="{ 'flex--space-between': isMobile(), 'ps-xsmall-y': enableModifySearch() === false }"
  >
    <fin-booking-header-summary
      [bookingSummary]="bookingSummary()"
      (modifySearch)="modifySearchDetails($event, isMobile())"
      [isClickable]="enableModifySearch()"
    />

    @if (enableModifySearch()) {
      <ng-container *ngTemplateOutlet="modifySearchButton" />
    }
  </div>
</ng-template>

<ng-template #modifySearchButton>
  @if (isMobile()) {
    <fcom-icon-button
      [theme]="IconButtonTheme.SECONDARY_OUTLINE_REVERSED"
      [icon]="{
        name: (expand.isOpen$ | async) ? SvgLibraryIcon.CLOSE_DELETE : SvgLibraryIcon.EDIT,
      }"
      [aria]="{
        label: ((expand.isOpen$ | async) ? 'actions.close' : 'bookingWidget.modifySearch') | finLocalization,
      }"
      (click)="toggleDetails()"
      data-testid="global-booking-widget-header-modify"
    />
  } @else {
    <fcom-button
      [icon]="{
        name: (expand.isOpen$ | async) ? SvgLibraryIcon.CLOSE_DELETE : SvgLibraryIcon.EDIT,
        position: IconPosition.LEFT,
      }"
      [theme]="ButtonTheme.SECONDARY_OUTLINE_REVERSED"
      [type]="ButtonType.MENU"
      [text]="((expand.isOpen$ | async) ? 'actions.close' : 'bookingWidget.modifySearch') | finLocalization"
      class="pr-small-l"
      (click)="toggleDetails()"
      data-testid="global-booking-widget-header-modify"
    />
  }
</ng-template>

<fin-expand
  [key]="EXPANDER_KEY"
  [id]="EXPANDER_KEY + '-' + ExpanderStatus.OPEN"
  [initiallyOpen]="false"
  [targetHeightElement]="TARGET_HEIGHT_ELEMENT.PARENT"
  [useCustomTrigger]="true"
  class="dn-mobile"
  #expand
>
  @if (enableModifySearch()) {
    <div class="content ps-medium-t ps-xsmall-b nordic-blue-900-text text-icon-primary grid-max-width center">
      <fin-booking-widget-common
        global-booking-widget
        [layout]="WidgetLayout.HORIZONTAL"
        (changeGlobalBookingWidgetExpanderStatus)="dispatchExpanderStatus($event)"
        [usePopoverSelectors]="true"
        [isGlobalBookingWidget]="true"
      />
    </div>
  }
</fin-expand>

@if (isMobile() && enableModifySearch()) {
  <fcom-modal
    [(open)]="modalOpen"
    [title]="'bookingWidget.modifySearch' | finLocalization"
    [buttons]="null"
    class="nordic-blue-900-bg surface-contrast"
    data-testid="global-booking-widget-header-mobile-modal"
  >
    <div class="grow scroll nordic-blue-900-bg surface-contrast">
      <div class="content ps-medium-x ps-small-b ps-xxsmall-t nordic-blue-900-text text-icon-primary">
        <ng-container [ngTemplateOutlet]="bookingHeaderSummary" />

        <fin-booking-widget-common
          global-booking-widget
          [layout]="WidgetLayout.HORIZONTAL"
          (changeGlobalBookingWidgetExpanderStatus)="dispatchExpanderStatus($event)"
          [usePopoverSelectors]="true"
          [isGlobalBookingWidget]="true"
        />
      </div>
    </div>
  </fcom-modal>
}

<ng-template #popoverContent>
  <div data-testid="promo-popover-content" class="ps-medium rounded-large">
    <header class="flex flex--space-between">
      <fcom-tag>{{ 'bookingWidget.globalWidgetPromo.tag' | finLocalization }}</fcom-tag>
    </header>
    <p class="ps-small-y font-body-medium">
      {{ 'bookingWidget.globalWidgetPromo.renewed.text' | finLocalization }}
    </p>
  </div>
</ng-template>
